import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM8.5,12a2,2,0,1,1-2-2A2,2,0,0,1,8.5,12ZM12,10a2,2,0,1,1-2,2A2,2,0,0,1,12,10Zm5.5,4a2,2,0,1,1,2-2A2,2,0,0,1,17.5,14Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }